// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

export async function createUser({
  id = null,
  name = null,
  email = null,
  role = null,
  organizationId = null,
  auth0Id = null,
  cageCode = null,
  phoneNumber = null,
  iconStatus = null,
  permissions = [],
}) {
  // Format Mutation
  const query = `mutation createUser(
    $user: NewUserInput
  ) {
     createUser(user:$user)
      {
        name,
        email,
        role,
        organizationId,
        phoneNumber,
      } 
    }`;

  // Variables
  const variables = {
    user: { id, name, email, role, organizationId, phoneNumber, auth0Id, cageCode, iconStatus, permissions },
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function updateUser(updateUserObj) {
  // Format Query
  const query = `mutation EditRequest($userInput: EditUserInput) {
    updateRequest(user: $userInput) {
      id,
      role,
      name,
      email
      phoneNumber
      organizationId
      iconStatus   
    }
  }`;

  // Variables
  const variables = { userInput: updateUserObj };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function requestUser(updateUserObj) {
  // Format Query
  const query = `mutation requestUser($user: NewUserInput) { requestUser (user: $user) { id, name, email, role, organizationId } }`;

  // Variables
  const variables = { user: updateUserObj };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export default {
  updateUser,
  requestUser,
};



// WEBPACK FOOTER //
// ./src/graphql/updateUsers.js